import Constants from './PassConstants';

export default { Constants };
